// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__22Efg","subheader":"ReorderModal_subheader__2qaYF","listWrap":"ReorderModal_listWrap__2pDAK"};